<app-overlay-spinner [hidden]="!isBusy"></app-overlay-spinner>
<ng-container *ngIf="!isBusy">
  <c-header position="sticky" class="" style="background-color: #ffffff !important">
    <button *ngIf="globals.isAdmin && !isLoginPage" cSidebarToggle="mainSidebar" toggle="visible" cHeaderToggler class="btn">
      <i class="fa fa-bars"></i>
    </button>
    <c-header-brand>
      <a class="navbar-brand adient-brand" href="javascript:void(0);" [ngStyle]="{'margin-left': (globals.isAdmin) ? '0px' : '30px'}">
        &nbsp;<span class="brand-text-dark" style="color: #00465B">{{appConfig.title1}}</span>
        <span class="brand-text-light">{{appConfig.title2}}</span>
      </a>
      <a class="navbar-brand adient-brand app-title-brand" href="javascript:void(0);" style="color: #00465B" *ngIf="appConfig.applicationName && appConfig.applicationName !== ''">
        {{appConfig.applicationName}}
      </a>
    </c-header-brand>
    <c-header-nav class="ml-auto">
      <ul class="nav nav-menu navbar-nav ml-auto">
        <li class="nav-item dropdown" [class.show]="openDropdown === 'create'" placement="bottom right" *ngIf="appConfig.showCreate  && appConfig.createOptions && appConfig.createOptions.length>0">
          <button class="btn menu-btn dropdown-toggle" type="button" aria-haspopup="true"
            [attr.aria-expanded]="openDropdown === 'create'" (click)="toggleDropdown('create')">
            UI
          </button>
          <div class="dropdown-menu dropdown-menu-right" [class.show]="openDropdown === 'create'" style="left: auto; right: 0px; min-width: 150px !important;"
            aria-labelledby="simple-dropdown">
            <a class="dropdown-item" *ngFor="let option of appConfig.createOptions" [routerLink]="option.link" (click)="closeDropdown()">
              <i class="nav-submenu-icon" *ngIf="option.icon" [ngClass]="option.icon"></i>{{option.title}}
            </a>
          </div>
        </li>
        <!--Help Menu-->
        <li class="nav-item dropdown" [class.show]="openDropdown === 'help'" placement="bottom right" style="margin-left: 20px;" *ngIf="appConfig.showHelp">
          <button class="btn menu-btn dropdown-toggle" type="button" aria-haspopup="true"
            [attr.aria-expanded]="openDropdown === 'help'" (click)="toggleDropdown('help')">
            Help
          </button>
          <div class="dropdown-menu dropdown-menu-right" [class.show]="openDropdown === 'help'" style="left: auto; right: 0px; min-width: 200px !important;"
            aria-labelledby="simple-dropdown">
            <a class="dropdown-item" (click)="openHelp(); closeDropdown()" href="javascript:void(0);">
              <i class="fa fa-life-ring nav-submenu-icon"></i>Support
            </a>
            <a class="dropdown-item" (click)="openHelpTutorials(); closeDropdown()" href="javascript:void(0);">
              <i class="fa fa-question-circle-o nav-submenu-icon"></i>Tutorials
            </a>
          </div>
        </li>
        <!--Settings Menu-->
        <li class="nav-item dropdown" [class.show]="openDropdown === 'settings'" placement="bottom right" *ngIf="appConfig.showSettings && globals.isAuthenticated">
          <a class="nav-link" href="javascript:void(0);" role="button" aria-haspopup="true"
            [attr.aria-expanded]="openDropdown === 'settings'" (click)="toggleDropdown('settings')">
            <i class="material-icons">settings</i>
          </a>
          <div class="dropdown-menu dropdown-menu-right" [class.show]="openDropdown === 'settings'" style="left: auto; right: 0px; min-width: 300px !important;"
            aria-labelledby="simple-dropdown">
            <div class="dropdown-header-main text-center"><strong>{{globals.user?.firstName}} {{globals.user?.lastName}}</strong></div>
            <div class="dropdown-header text-center"><strong>Settings</strong></div>
            <a class="dropdown-item" (click)="logout()">
              <i class="fa fa-sign-out nav-submenu-icon"></i>Logout
            </a>
          </div>
        </li>
      </ul>
    </c-header-nav>
  </c-header>

  <div class="app-body" [style.marginTop]="navigationClosed ? '0' : ''">
    <c-sidebar #appSidebar id="mainSidebar" position="fixed" [unfoldable]="sidebarMinimized" [(visible)]="sidebarVisible"
      *ngIf="globals.isAdmin && !isLoginPage">
      <c-sidebar-nav [navItems]="navItems"></c-sidebar-nav>
      <c-sidebar-footer>
        <button cSidebarToggle="mainSidebar" toggle="unfoldable" class="btn sidebar-minimizer">
        </button>
      </c-sidebar-footer>
    </c-sidebar>

    <!-- Main content -->
    <main class="main" style="background-color: #ffffff">
      <div class="container-fluid" style="margin-top: 10px;margin-bottom: 70px;">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
  <c-footer [style.marginLeft.px]="sidebarOffset">
    <!-- <div class="ml-auto" style="text-align: right;">
      <span style="font-weight: bold !important;font-size: 14px;margin-right: 5%;
      color: #23282c;">Built on</span><br/>
      <a href="https://noaharkappstore-web-dev.azurewebsites.net/about/smartapps.html" target="_blank">
        <img src="assets/img/smartapps-dark.png" alt="SmartApps" style="height:30%;width:15%"/>
      </a>
    </div> -->
</c-footer>
</ng-container>